import styled from 'styled-components';
import colors from 'Styles/colors';
import { GrAnnounce } from 'react-icons/gr';
import { FaLongArrowAltRight, FaLock } from 'react-icons/fa';
import { ReactComponent as CloseIconSvg } from 'Images/icon-close.svg';

export const TYPE_COLORS = {
  new: colors.blueCerulean,
  improvement: colors.green9,
  fix: colors.orange2
};

// Purple/blue instead of the item-type colors above, so a license chip never
// reads as another type badge.
export const LICENSE_COLORS = {
  professional: colors.blue9,
  corporate: colors.purple2
};

export const Wrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.backgrounds.modal};
  text-align: left;
  line-height: 1.44;
  border-radius: 10px !important;
  max-width: ${(props) => props.maxWidth};
  padding: 25px !important;
  display: flex;
  flex-direction: column;
`;

Wrapper.displayName = 'WhatsNewWrapper';

export const CloseIcon = styled(CloseIconSvg)`
  width: 20px;
  height: 20px;
  align-self: start;
  cursor: pointer;

  * > path {
    color: ${({ theme }) => theme.text.modalTitle2};
  }
`;
CloseIcon.displayName = 'CloseIcon';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
Header.displayName = 'Header';

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;
HeaderContent.displayName = 'HeaderContent';

export const HeaderIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 41px;
  height: 41px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.backgrounds.modal4};
  flex-shrink: 0;
`;
HeaderIconBox.displayName = 'HeaderIconBox';

export const HeaderIcon = styled(GrAnnounce)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  path {
    stroke: ${({ theme }) => theme.buttons.primary.background};
  }
`;
HeaderIcon.displayName = 'HeaderIcon';

export const HeaderTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;
HeaderTextColumn.displayName = 'HeaderTextColumn';

export const PrimaryTitle = styled.div`
  font-size: 21.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
PrimaryTitle.displayName = 'PrimaryTitle';

export const Subtitle = styled.div`
  font-size: 13px;
  color: ${colors.grey19};
`;
Subtitle.displayName = 'Subtitle';

export const TabBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 18px;
  margin-bottom: 22px;
`;
TabBar.displayName = 'TabBar';

export const TabButton = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active, theme }) =>
    $active ? theme.text.modalTitle2 : colors.grey19};
`;
TabButton.displayName = 'TabButton';

export const TabBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: ${colors.white};
  background-color: ${colors.blueCerulean};
`;
TabBadge.displayName = 'TabBadge';

export const TabDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${colors.blueCerulean};
  flex-shrink: 0;
`;
TabDot.displayName = 'TabDot';

export const ItemList = styled.div`
  height: 340px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 8px;
`;
ItemList.displayName = 'ItemList';

export const ItemCard = styled.div``;
ItemCard.displayName = 'ItemCard';

export const ItemHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 4px;
`;
ItemHeader.displayName = 'ItemHeader';

export const BadgeRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;
BadgeRow.displayName = 'BadgeRow';

export const TitleContainer = styled.div`
  display: flex;
  gap: 7px;
`;
TitleContainer.displayName = 'TitleContainer';

export const TypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: ${colors.white};
  background-color: ${({ $type }) => TYPE_COLORS[$type] || colors.grey19};
  white-space: nowrap;
`;
TypeBadge.displayName = 'TypeBadge';

export const ItemTitle = styled.span`
  font-size: 14.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
ItemTitle.displayName = 'ItemTitle';

export const LicenseBadge = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 1;
  gap: 4px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  color: ${colors.white};
  background-color: ${({ $license }) =>
    LICENSE_COLORS[$license] || colors.grey19};
  white-space: nowrap;
`;
LicenseBadge.displayName = 'LicenseBadge';

export const LicenseIcon = styled(FaLock)`
  width: 8px;
  height: 8px;
  flex-shrink: 0;
`;
LicenseIcon.displayName = 'LicenseIcon';

export const ItemDescription = styled.p`
  font-size: 13px;
  line-height: 1.45;
  color: ${colors.grey19};
  margin: 0 0 6px;
`;
ItemDescription.displayName = 'ItemDescription';

export const ItemActions = styled.div`
  display: flex;
`;
ItemActions.displayName = 'ItemActions';

export const ActionLink = styled.a`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: ${colors.blueCerulean};
`;
ActionLink.displayName = 'ActionLink';

export const ActionIcon = styled(FaLongArrowAltRight)`
  width: 12px;
  height: 12px;
  color: ${colors.blueCerulean};
  flex-shrink: 0;
`;
ActionIcon.displayName = 'ActionIcon';

export const Footer = styled.div`
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.borders.preferenceMenuLine};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
Footer.displayName = 'Footer';

export const ChangelogLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  font-weight: 500;
  color: ${colors.blueCerulean};
`;
ChangelogLink.displayName = 'ChangelogLink';
